<div class="component-wrapper">
    <div class="header">
        <p>{{ 'imgDb.classificatorTree.header' | translate }}</p>
    </div>
    <div class="tree-wrapper">
        <div
            class="tree"
            *ngIf="classificatorTree.size && isClassificatorTreeSet"
        >
            <ng-container
                *ngFor="
                    let keyValuePair of classificatorTree | keyvalue;
                    index as idx
                "
            >
                <div
                    class="node"
                    [ngClass]="{
                        'folded-out': classificatorTree.get(keyValuePair.key)
                            .open
                    }"
                >
                    <div
                        class="node-data"
                        (click)="toggleClassificatorDropdown(keyValuePair.key)"
                    >
                        <div class="icon">
                            <img
                                src="assets/svg/img-db/classificator-tree/arrow.svg"
                                alt="arrow-icon"
                            />
                        </div>
                        <div
                            class="color-dot"
                            [ngStyle]="{
                                backgroundColor: getColor(keyValuePair.key)
                            }"
                        ></div>
                        <p class="name">{{ keyValuePair.key }}</p>
                        <div class="children-count">
                            {{
                                classificatorTree.get(keyValuePair.key).items
                                    .length
                            }}
                        </div>
                        <div class="context-menu-wrapper" *ngIf="canEdit">
                            <div
                                class="three-dots-open-trigger"
                                *ngIf="parentContextMenuOpenFor !== idx"
                                (click)="onOpenContextMenu($event, idx)"
                            >
                                <img
                                    class="three-dots-icon"
                                    src="assets/svg/reusable-svg/icon-dots.svg"
                                    alt="three-dots"
                                />
                            </div>
                            <div
                                class="context-menu-items"
                                *ngIf="parentContextMenuOpenFor === idx"
                            >
                                <div
                                    class="close icon-wrapper"
                                    (click)="onCloseContextMenu($event)"
                                >
                                    <img
                                        src="assets/svg/reusable-svg/close-hover.svg"
                                        alt="close-icon"
                                    />
                                </div>
                                <div
                                    class="swap icon-wrapper"
                                    (click)="
                                        onSwapCategory($event, keyValuePair.key)
                                    "
                                    [title]="
                                        'imgDb.classificatorTree.contextMenu.swap.parent'
                                            | translate
                                    "
                                >
                                    <img
                                        src="assets/svg/img-db/classificator-tree/swap-white.svg"
                                        alt="delete-icon"
                                    />
                                </div>
                                <div
                                    class="delete icon-wrapper"
                                    (click)="
                                        deleteCategory($event, keyValuePair.key)
                                    "
                                    [title]="
                                        'imgDb.classificatorTree.contextMenu.delete.parent'
                                            | translate
                                    "
                                >
                                    <img
                                        src="assets/svg/img-db/classificator-tree/delete.svg"
                                        alt="delete-icon"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="children">
                        <ng-container
                            *ngFor="
                                let classificatorTreeItem of classificatorTree.get(
                                    keyValuePair.key
                                ).items;
                                index as childIdx
                            "
                        >
                            <div
                                class="node-data"
                                [ngClass]="{
                                    active: classificatorTreeItem.active
                                }"
                                (click)="
                                    selectClassificator(classificatorTreeItem)
                                "
                            >
                                <div
                                    class="color-dot"
                                    [ngStyle]="{
                                        backgroundColor: getColor(
                                            keyValuePair.key
                                        )
                                    }"
                                ></div>
                                <p class="child-name">{{ keyValuePair.key }}</p>
                                <div
                                    class="context-menu-wrapper"
                                    *ngIf="canEdit"
                                >
                                    <div
                                        class="three-dots-open-trigger"
                                        *ngIf="
                                            childContextMenuOpenFor.childIdx !==
                                                childIdx ||
                                            childContextMenuOpenFor.parentIdx !==
                                                idx
                                        "
                                        (click)="
                                            onOpenChildContextMenu(
                                                $event,
                                                idx,
                                                childIdx
                                            )
                                        "
                                    >
                                        <img
                                            class="three-dots-icon"
                                            src="assets/svg/reusable-svg/icon-dots.svg"
                                            alt="three-dots"
                                        />
                                    </div>
                                    <div
                                        class="context-menu-items"
                                        *ngIf="
                                            childContextMenuOpenFor.parentIdx ===
                                                idx &&
                                            childContextMenuOpenFor.childIdx ===
                                                childIdx
                                        "
                                    >
                                        <div
                                            class="close icon-wrapper"
                                            (click)="onCloseContextMenu($event)"
                                        >
                                            <img
                                                src="assets/svg/reusable-svg/close-hover.svg"
                                                alt="close-icon"
                                            />
                                        </div>
                                        <div
                                            class="swap icon-wrapper"
                                            (click)="
                                                onSwapCategory(
                                                    $event,
                                                    keyValuePair.key,
                                                    classificatorTreeItem.annotationId
                                                )
                                            "
                                            [title]="
                                                'imgDb.classificatorTree.contextMenu.swap.child'
                                                    | translate
                                            "
                                        >
                                            <img
                                                src="assets/svg/img-db/classificator-tree/swap-white.svg"
                                                alt="delete-icon"
                                            />
                                        </div>
                                        <div
                                            class="delete icon-wrapper"
                                            (click)="
                                                deleteAnnotation(
                                                    $event,
                                                    classificatorTreeItem
                                                )
                                            "
                                            [title]="
                                                'imgDb.classificatorTree.contextMenu.delete.child'
                                                    | translate
                                            "
                                        >
                                            <img
                                                src="assets/svg/img-db/classificator-tree/delete.svg"
                                                alt="delete-icon"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
        <div
            class="empty-tree-wrapper"
            *ngIf="!classificatorTree.size && isClassificatorTreeSet"
        >
            <p>{{ 'imgDb.classificatorTree.emptyTreeMessage' | translate }}</p>
        </div>
        <div
            class="spinner-wrapper"
            *ngIf="annotationStateService.$loading | async"
        >
            <div class="tryb-design-spinner"></div>
        </div>
    </div>
</div>
